import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid gap-4 min-[700px]:grid-cols-2" }
const _hoisted_2 = { class: "flex flex-col gap-1.5 text-sm font-medium text-gray-700" }
const _hoisted_3 = { class: "flex flex-col gap-1.5 text-sm font-medium text-gray-700" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  "data-number-saved": "",
  class: "text-sm text-gray-600"
}
const _hoisted_6 = {
  key: 0,
  "data-number-error": "",
  role: "alert",
  class: "m-0 text-sm text-red-700"
}

import 'intl-tel-input/build/css/intlTelInput.css'

import intlTelInput from 'intl-tel-input'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'

const INPUT_CLASS =
  'block w-full rounded-md border border-gray-300 px-2.5 py-2 text-sm font-normal leading-5 text-gray-900 shadow-sm'
// Same as NewContactModal.
const UTILS_SCRIPT = 'https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.6/build/js/utils.js'
const SAVE_ERROR = 'Your number could not be saved. Try again.'


export default {
  __name: 'AgentTestNumberSection',
  props: {
  testContact: { type: Object, default: null },
  suggestedFirstName: { type: String, default: '' }
},
  emits: ['saved'],
  setup(__props, { emit: __emit }) {

const COUNTRY_CODES = { USA: 'US', AUS: 'AU', CAN: 'CA', GBR: 'GB' }
const props = __props
const emit = __emit

const store = useStore()

const firstName = ref(props.testContact?.display_name || props.suggestedFirstName || '')
const savedPhone = props.testContact?.phone_formatted || ''
const phone = ref(savedPhone)
// A saved number is valid until the merchant edits it (intl-tel-input reformats it on init).
const edited = ref(false)
const valid = ref(Boolean(savedPhone))
const saving = ref(false)
const error = ref('')
const savedNote = ref('')
const phoneInput = ref(null)
let iti = null

// The merchant's own sending number, from the logged-in user record (as the country getter reads it).
const bottleNumber = computed(
  () => mapRelationship({ type: 'user', id: String(store.getters.loggedInUserId) })?.attributes?.phone_formatted
)
const fromBottleNumber = computed(() =>
  bottleNumber.value ? `your Bottle number, ${bottleNumber.value}` : 'your Bottle number'
)
const help = computed(
  () =>
    `We'll add you as a customer so the agents can text you. Replies come from ${fromBottleNumber.value}. Texts to this number are test messages to you.`
)
const canSave = computed(() => valid.value && !saving.value)

watch(phone, () => {
  edited.value = true
  valid.value = Boolean(iti?.isValidNumber?.())
})

onMounted(() => {
  if (!phoneInput.value) return
  iti = intlTelInput(phoneInput.value, {
    utilsScript: UTILS_SCRIPT,
    preferredCountries: [COUNTRY_CODES[store.getters.country]],
    countrySearch: false
  })
})
onBeforeUnmount(() => iti?.destroy())

// The international form from intl-tel-input; an untouched saved number may fall back to what was saved.
const phoneToSend = () => {
  const number = iti?.getNumber?.() || ''
  return edited.value ? number : number || savedPhone
}

const save = async () => {
  if (!canSave.value) return
  saving.value = true
  error.value = ''
  savedNote.value = ''
  try {
    const response = await api.call(
      'PUT',
      'agents/test_number',
      { phone: phoneToSend(), first_name: firstName.value.trim() },
      { receive: false, save: false }
    )
    savedNote.value = 'Saved'
    emit('saved', response.data.data)
  } catch (failure) {
    error.value = failure?.response?.data?.errors?.[0] ?? SAVE_ERROR
  } finally {
    saving.value = false
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(WizardSection, {
    title: "Your mobile number",
    description: help.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _cache[2] || (_cache[2] = _createTextVNode(" Your first name ", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((firstName).value = $event)),
            name: "first_name",
            type: "text",
            autocomplete: "given-name",
            class: _normalizeClass(INPUT_CLASS),
            onKeyup: _withKeys(save, ["enter"])
          }, null, 544), [
            [_vModelText, firstName.value]
          ])
        ]),
        _createElementVNode("label", _hoisted_3, [
          _cache[3] || (_cache[3] = _createTextVNode(" Mobile number ", -1)),
          _withDirectives(_createElementVNode("input", {
            ref_key: "phoneInput",
            ref: phoneInput,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((phone).value = $event)),
            name: "phone",
            type: "tel",
            autocomplete: "tel",
            class: _normalizeClass(INPUT_CLASS),
            onKeyup: _withKeys(save, ["enter"])
          }, null, 544), [
            [_vModelText, phone.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(WizardButton, {
          variant: "primary",
          disabled: !canSave.value,
          loading: saving.value,
          onClick: save
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "loading"]),
        (savedNote.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(savedNote.value), 1))
          : _createCommentVNode("", true)
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["description"]))
}
}

}